import React from 'react'
import { makeStyles, Fab } from '@material-ui/core'
import { Icon } from 'packages/eid-icons'

const useStyles = makeStyles((theme) => ({
    root: (props) => ({
        textTransform: 'capitalize',
        fontSize: '14px',
        lineHeight: 1.2,
        height: '31px !important',
        margin: '8px 0px !important',
        width: '100% !important',
        backgroundColor: '#f7f8fa',
        color: '#01ae8f',
        boxShadow: 'none',
        border: '1px solid #01ae8f',
        overflowWrap: 'anywhere',
        '& svg': {
            color: '#01ae8f',
            position: 'absolute',
            right: '12px',
            top: '50%',
            transform: 'translateY(-50%)',
        },
        '&:hover': {
            backgroundColor: '#f7f8fa',
        },
        ...props.styles,
    }),

    disabled: {
        backgroundColor: '#f7f8fa !important',
        border: '1px solid #8b909a !important',

        color: '#8b909a !important',
        '& svg': {
            color: '#8b909a !important',
        },
    },
}))
const AddAllButton = ({
    styles,
    active,
    iconName,
    startIcon,
    children,
    activeStyle,
    ...rest
}) => {
    const classes = useStyles({ styles })
    return (
        <Fab variant="extended" size="small" classes={classes} {...rest}>
            {startIcon && (
                <Icon
                    name={iconName ? iconName : 'Forward'}
                    color={styles?.color ? styles.color : '#ffffff'}
                    className={classes.icon}
                ></Icon>
            )}
            {children}

            {!startIcon && (
                <Icon
                    name={iconName ? iconName : 'SmallArrow'}
                    color={styles?.color ? styles.color : '#ffffff'}
                    className={classes.icon}
                ></Icon>
            )}
        </Fab>
    )
}

export default AddAllButton
